import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/DSB-Logo.svg";
import Menu from "./Menu";
import ServiceMenu from "./ServiceMenu";
import menuProfile from "../assets/images/menu-profile.png";
import menuIcon from "../assets/images/menu-hamburger-menu.png";
import styles from "../css/menu.module.css";
import { auth } from "../services/auth";
import { useAuth } from "../services/AuthProvider";
import CartIcon from "./cartIcon";

export default function Header() {
  const [showMenu, setShowMenu] = useState(false);
  const [showServiceMenu, setShowServiceMenu] = useState(false);
  const [currentLocation, setCurrentLocation] = useState("");
  const [localUser, setLocalUser] = useState("");
  const location = useLocation();

  const toggleMenu = () => {
    setShowMenu(!showMenu);
    if (showServiceMenu) {
      setShowServiceMenu(false);
    }
  };

  const toggleServiceMenu = () => {
    setShowServiceMenu(!showServiceMenu);
    if (showMenu) {
      setShowMenu(false);
    }
  };
  useEffect(() => {
    const data = auth().getUser();
    setLocalUser(data);
  }, [useAuth().auth]);

  useEffect(() => {
    if (currentLocation !== location.pathname) {
      setShowMenu(false);
    }
    setCurrentLocation(location.pathname);
  }, [location]);

  return (
    <header className="container mx-auto px-16">
      <div className="mb-2 md:flex md:flex-row justify-center md:justify-between lg:justify-between items-center space-y-3 md:space-y-0 font-semibold">
        <div className="flex justify-center md:justify-start xl:-mb-16 lg:-mb-16 sm:-mb-18 z-10 sm:max-h-72">
          <a className="flex-none hover:opacity-75 transition-all" href="/">
            <img
              src={logo}
              alt="DailySocialBoost Logo"
              className="mr-auto "
              height={280}
              width={200}
            />
          </a>
        </div>
        <div className="mt-2 flex justify-around md:justify-center ">
          <div className="mt-2 flex justify-around md:justify-center ">
            <button
              onClick={toggleServiceMenu}
              className="mx-0 md:mx-10 px-5 py-3 2xl:hidden md:block xl:hidden lg:hidden sm:hidden hidden uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all"
            >
              Services
            </button>
            <Link title="Cart" to="/cart" className="space-y-2 min-w-fit mx-2 lg:hidden">
              <CartIcon />
            </Link>
          </div>
          <div className="mt-2 flex justify-center">
            {localUser ? (
              <Link
                title="Profile"
                to="/settings"
                className="space-y-2 min-w-fit mx-2 lg:hidden block z-10"
              >
                <img src={menuProfile} alt="Profile" height={40} width={40} />
              </Link>
            ) : (
              <>
                <li className="lg:flex lg:flex-none list-none block z-10">
                  <Link
                    title="Log in"
                    className={`${styles.menuLink} ${
                      location.pathname === "/login" ? "text-pink-350" : ""
                    } pt-2 transition-all lg:hidden inline-flex`}
                    to="/login"
                  >
                    Log in
                  </Link>
                </li>
                <li className="lg:flex lg:flex-none list-none block z-10">
                  <Link
                    title="Sign up"
                    className={`${styles.menuLink} ${
                      location.pathname === "/signup" ? "text-pink-350" : ""
                    } ${styles.signUpBtn} transition-all lg:hidden inline-flex`}
                    to="/signup"
                  >
                    Sign up
                  </Link>
                </li>
              </>
            )}
            <button
              title="Menu"
              onClick={toggleMenu}
              className="space-y-2 mx-2 2xl:hidden md:hidden xl:hidden lg:hidden sm:block block z-10"
            >
              <img src={menuIcon} alt="Menu" height={40} width={40} />
            </button>
          </div>
          <div className="hidden lg:inline-flex">
            <Menu className="grow" />
          </div>
        </div>
      </div>
      {showMenu ? (
        <div className="flex flex-col justify-end">
          <div className="z-20 lg:hidden mt-10">
            <Menu className="grow" />
          </div>
        </div>
      ) : null}
      <div className="lg:flex lg:flex-row lg:justify-end hidden">
        <ServiceMenu className="grow" />
      </div>
      {showServiceMenu ? (
        <div className="flex flex-col justify-end">
          <div className="z-20 lg:hidden mt-10">
            <ServiceMenu className="grow" />
          </div>
        </div>
      ) : null}
    </header>
  );
}
